import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    intraday_updates: []
  },
  actions: actions,
  mutations: mutations,
  getters: getters
}
